import { ArrowLeft } from 'lucide-react';
import { motion } from 'motion/react';
import { ScrollArea } from './ui/scroll-area';
import { ParallaxBackground } from './utils/parallax';
import { TITLES, CONTENTS, type LegalDocumentType } from '../constants/legalDocuments';
import { LegalMarkdown } from './ui/LegalMarkdown';

interface LegalScreenProps {
  type: LegalDocumentType;
  onBack: () => void;
}

export function LegalScreen({ type, onBack }: LegalScreenProps) {
  const content = CONTENTS[type];
  const title = TITLES[type];

  return (
    <div className="w-full h-screen bg-[#0a0a0a] transition-colors duration-300 relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <ParallaxBackground speed={0.05} />
      </div>
      <ScrollArea className="h-full overflow-y-auto w-full" style={{ WebkitOverflowScrolling: 'touch' }}>
        <div className="w-full max-w-2xl mx-auto relative z-10 min-h-screen pb-20">
          {/* Header */}
          <div
            className="p-4 border-b border-white/10 bg-black/80 backdrop-blur-lg sticky top-0 z-20"
            style={{ paddingTop: 'max(60px, calc(env(safe-area-inset-top) + 32px))' }}
          >
            <div className="flex items-center gap-4">
              <motion.button
                whileTap={{ scale: 0.95 }}
                onClick={onBack}
                className="text-[#E5E5E5] hover:text-white"
              >
                <ArrowLeft className="w-6 h-6" />
              </motion.button>
              <div>
                <h1 className="text-2xl text-white font-bold">
                  {title}
                </h1>
              </div>
            </div>
          </div>

          <div className="p-6">
            <div className="p-6 rounded-2xl bg-[#111111] border border-white/10 card-shadow">
              <div className="space-y-3">
                <LegalMarkdown content={content} />
              </div>
            </div>
          </div>
        </div>
      </ScrollArea>
    </div>
  );
}
